import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzTooltipModule } from 'ng-zorro-antd/tooltip';

import { IUser } from '../../../../core/store/user/models/UserMe';
import { CustomTooltipDirective } from '../../directives/custom-tooltip.directive';
import { NotificationService } from '../../services/notification.service';
import { ChipComponent } from '../chip/chip.component';
import { SvgIconComponent } from '../svg-icon/svg-icon.component';
import {
  IMenuItem,
  IMenuListItem,
  MENU_ITEMS,
  PROFILE_ITEMS,
} from './sidebar.config';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss',
  imports: [
    CommonModule,
    RouterModule,
    NzDropDownModule,
    NzTooltipModule,
    SvgIconComponent,
    ChipComponent,
    CustomTooltipDirective,
  ],
})
export class SidebarComponent implements OnChanges, OnInit {
  @Input() user: IUser;
  @Input() isCollapsed = false;

  UnreadNotifications = 0;

  // Controls the profile dropdown so it can be closed when a menu item is
  // clicked (the custom routerLink items don't auto-close it like nz-menu does).
  profileMenuVisible = false;

  MENU_ITEMS = MENU_ITEMS;
  PROFILE_ITEMS = PROFILE_ITEMS;

  constructor(
    private readonly auth: AuthService,
    private notificationService: NotificationService,
    private readonly router: Router,
  ) {}

  /** Active through one of the item's `alsoActiveOn` prefixes (same subset match as routerLinkActive). */
  isAlsoActive(item: IMenuItem): boolean {
    return (
      item.alsoActiveOn?.some((url) =>
        this.router.isActive(url, {
          paths: 'subset',
          queryParams: 'ignored',
          fragment: 'ignored',
          matrixParams: 'ignored',
        }),
      ) ?? false
    );
  }

  auth0logout(): void {
    this.auth.logout({
      logoutParams: {
        returnTo: window.location.origin,
      },
    });
  }

  updateCounter(): void {
    this.notificationService.unreadCount$.subscribe((count) => {
      this.UnreadNotifications = count;
    });
  }

  ngOnInit(): void {
    this.updateCounter();
  }

  ngOnChanges(): void {
    this.updateCounter();
  }

  trackByName(index: number, item: IMenuListItem): string {
    return item.groupName ? item.groupName : index.toString();
  }

  trackByLabel(_index: number, item: IMenuItem): string {
    return item.label;
  }
}
